import { System, AllowedReducer, RoleReducer } from '@leverege/api-redux';
import { UserSettings, UI } from '@leverege/ui-redux';
import I18N from '@leverege/i18n';
import { UserRoles } from '@leverege/molten-core';
const {
  t
} = I18N.ns('molten.views.userSettings.Util');
function getCanSystemEffect(dispatch, canSystem) {
  return () => {
    if (canSystem == null) {
      dispatch(System(window.Molten.getConfig('api/systemId')).resource('ui').canUpdate());
    }
  };
}
function getCanSystem(state, props) {
  return AllowedReducer.get(state, System(window.Molten.getConfig('api/systemId')).resource('ui').getResourceId())?.updateRsrc;
}
function getProfiles(state, props, opts) {
  const {
    getProfileFn = 'getProfile',
    getValues = true
  } = opts || {};
  const {
    context: {
      settingsPath
    }
  } = props;
  const canSystem = getCanSystem(state, props);
  const prjId = window.Molten.getConfig('api/projectId');
  const roles = canSystem ? RoleReducer.getRoles(state?.roles, prjId).filter(UserRoles.createUIRoleFilter(window.Molten)) : UI.get(state)?.personas;
  const profiles = roles?.map(r => ({
    name: r.name,
    displayName: r.displayName || r.name,
    value: getValues ? UserSettings[getProfileFn](state, r.name, settingsPath) : null
  })) || [];
  profiles.push({
    name: 'default',
    displayName: t('default'),
    value: getValues ? UserSettings[getProfileFn](state, 'default', settingsPath) : null
  });
  return profiles;
}
export default {
  getProfiles,
  getCanSystem,
  getCanSystemEffect
};